import { render, staticRenderFns } from "./ViewCandidateScreeningQuestions.vue?vue&type=template&id=1551b00c&scoped=true&"
import script from "./ViewCandidateScreeningQuestions.vue?vue&type=script&lang=ts&"
export * from "./ViewCandidateScreeningQuestions.vue?vue&type=script&lang=ts&"
import style0 from "./ViewCandidateScreeningQuestions.vue?vue&type=style&index=0&id=1551b00c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1551b00c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VDialog,VForm,VIcon,VSkeletonLoader})
